import * as React from 'react';
import { Typography } from 'fronton-react';
import { getLocale, jc, getNumberFormatter } from 'utils';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import {
  descriptionStyle,
  flexVerticalCenter,
  image,
  leftSide,
  mediumPlusScreenProduct,
  mobileProduct,
  priceStyle,
  tabletProduct,
  textWrapper,
} from './product.styles';
import { ProductProps } from '../types/product-props';
import { OutOfStockMessage } from './out-of-stock-message';
import { useTranslation } from 'react-i18next';

const formatPrice = (locale: string, price: number) => {
  return getNumberFormatter(locale, {
    style: 'currency',
    currency: 'RUB',
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(price);
};

// FIXME
/**
 * @deprecated Use ProductPriceView
 */
export const ProductPrice: React.FC<{ price: number; onClick: () => void }> = ({ price, onClick }) => {
  const locale = getLocale();

  return (
    <Typography data-qa="price-sticky" onClick={onClick} variant="m" size="subtitle" className={priceStyle}>
      {formatPrice(locale, price)}
    </Typography>
  );
};

export const ProductImage: React.FC<{ url: string; description: string; onClick: () => void }> = ({
  description,
  onClick,
  url,
}) => {
  const { t } = useTranslation();
  return (
    <ImagePlaceholder
      onClick={onClick}
      alt={description}
      fallbackAlt={t('ui.image.alt')}
      src={url}
      loading="lazy"
      className={image}
      fallbackWidth={40}
      fallbackHeight={40}
    />
  );
};

export const ProductDescription: React.FC<{ description: string }> = ({ description }) => {
  return (
    <Typography variant="s" size="body_short" className={descriptionStyle}>
      {description}
    </Typography>
  );
};

export const MobileProduct: React.FC<ProductProps> = ({
  BasketItem,
  availabilityState,
  onSectionActivated,
  slots,
}) => {
  return (
    <>
      <div data-qa="mobile-product" className={mobileProduct}>
        <div className={leftSide}>
          {slots.image}
          <div className={textWrapper}>
            {slots.description}
            {availabilityState.availability === 'available' ? (
              slots.price
            ) : (
              <OutOfStockMessage onSectionActivated={onSectionActivated} />
            )}
          </div>
        </div>
        {availabilityState.availability === 'available' ? BasketItem : null}
      </div>
    </>
  );
};

export const TabletProduct: React.FC<ProductProps> = ({
  BasketItem,
  availabilityState,
  onSectionActivated,
  slots,
}) => (
  <>
    <div data-qa="tablet-product" className={tabletProduct}>
      {availabilityState.availability === 'available' ? (
        <>
          <div className={leftSide}>
            {slots.image}
            <div className={textWrapper}>
              <div>{slots.description}</div>
              {slots.price}
            </div>
          </div>
          <div>{/* div for `flex-shrink: 0` effect */ BasketItem}</div>
        </>
      ) : (
        <>
          <div className={leftSide}>
            {slots.image}
            <div className={jc(textWrapper, flexVerticalCenter)}>{slots.description}</div>
          </div>
          <OutOfStockMessage onSectionActivated={onSectionActivated} />
        </>
      )}
    </div>
  </>
);

export const MediumPlusScreenProduct: React.FC<ProductProps> = ({
  BasketItem,
  availabilityState,
  onSectionActivated,
  slots,
}) => (
  <>
    {availabilityState.availability === 'available' ? (
      <div className={jc(mediumPlusScreenProduct, 'spaceBetween')}>
        {slots.price}
        {slots.image}
        {BasketItem}
      </div>
    ) : (
      <div className={jc(mediumPlusScreenProduct, 'flexEnd')}>
        <OutOfStockMessage onSectionActivated={onSectionActivated} />
        {slots.image}
      </div>
    )}
  </>
);
